export default {
    hasPendingInvoices: undefined,
}
